import { tenantSettingsAPI } from '@/providers/apis/tenant-settings/tenant-settings';

export default({
    namespaced: true,

    state: {
        tenantSettings : [],
    },

    mutations: {
        fetchTenantSettings(state: any, data: any) {
            state.tenantSettings = data;
        },
    },

    actions: {

        fetchTenantSettings: (context: any) => {
            return tenantSettingsAPI.fetchTenantSettings().then((tenantSettings) => {
                context.commit('fetchTenantSettings', tenantSettings);
            });
        },

    },
});
